import React from "react";
import { Row, Table, Button } from "react-bootstrap";
import numeral from "numeral";

const ItemList = ({ items, removeItem }) => (
  <Row>
    <Table>
      <thead>
        <tr>
          <th>Desc</th>
          <th>QTY</th>
          <th>Weight</th>
          <th>UOM</th>
          <th>Freight Charge</th>
        </tr>
      </thead>
      <tbody>
        {items.map((item, index) => (
          <tr key={index}>
            <td>{item.name}</td>
            <td>{numeral(item.qty).format("0,0")}</td>
            <td>{numeral(item.weight).format("0,0")}</td>
            <td>{item.uom}</td>
            <td>{numeral(item.amount).format("0,0.00")}</td>
            <td>
              <Button onClick={() => removeItem(item)}>Remove</Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  </Row>
);

export default ItemList;
